module.exports = __webpack_public_path__ + "static/media/empty_store_list.cabab79f.svg";